import React, { useState, useEffect } from 'react';
import {
  Card,
  Button,
  Row,
  Col,
  Modal,
  Form,
  Input,
  message,
  Spin,
} from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { getScrapInvalidDomains, saveScrapInvalidDomains } from '../../../services/ReportsApi';
import { Switch } from '@mui/material';

export interface SaveScrapInvalidDomain {
    domain: string;
    isActive: boolean;
}

export interface ScrapInvalidDomain {
    id: number;
    domain: string;
    isActive: boolean;
    createdAt: Date;
    updatedAt: Date;
}

const InvalidDomainsModal: React.FC<{
    visible: boolean;
    onClose: () => void;
  }> = ({ visible, onClose }) => {
  const [domains, setDomains] = useState<ScrapInvalidDomain[]>([]);
  const [loading, setLoading] = useState(false);
  const [updateloading, setUpdateLoading] = useState(false);
  const [form] = Form.useForm();

  const loadDomains = async () => {
    setLoading(true);
    try {
      const data = await getScrapInvalidDomains();
      setDomains(data);
    } catch (error) {
      message.error('Error cargando los dominios inválidos');
    } finally {
      setLoading(false);
    }
  };
  
  const handleAddDomain = async (values: { domain: string }) => {
    try {
      await saveScrapInvalidDomains({
        domain: values.domain,
        isActive: true,
      });
      message.success('Dominio agregado');
      form.resetFields();
      loadDomains();
    } catch (error: any) {
      message.error(error?.response?.data?.message || 'Error agregando el dominio');
    }
  };
  
  const handleUpdateDomain = async (id: number, domain: string, isActive: boolean) => {
    setUpdateLoading(true);
    try {        
      await saveScrapInvalidDomains({
        id,
        domain,
        isActive,
      });
      message.success('Dominio actualizado.');
      loadDomains();
    } catch (error) {
      message.error('Error actualizando el registro');
    } finally {
      setUpdateLoading(false);
    }
  };
  
  useEffect(() => {
    if (visible) {
      loadDomains();
    }
  }, [visible]);

  return (
    <Modal
      title="Dominios excluidos"
      open={visible}
      onCancel={onClose}
      footer={null}
      width={600}
    >
      <Spin spinning={loading}>
        <Form form={form} onFinish={handleAddDomain} layout="vertical">
          <Row gutter={16}>
            <Col span={18}>
              <Form.Item
                name="domain"
                label="Nuevo Dominio"
                rules={[{ required: true, message: 'Por favor agrega un nuevo dominio' }]}
              >
                <Input placeholder="example.com" />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item label=" ">
                <Button type="primary" htmlType="submit" icon={<PlusOutlined />}>
                  Agregar
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>

        <div style={{ maxHeight: 400, overflowY: 'auto' }}>
          {domains.map(domain => (
            <Card key={domain.id} size="small" style={{ marginBottom: 8 }}>
              <Row align="middle" gutter={16}>
                <Col flex={1}>
                  <Input
                      readOnly
                      defaultValue={domain.domain}
                  />
                </Col>
                <Col>
                  <Switch
                      disabled={updateloading}
                      checked={domain.isActive}
                      onChange={(e, v) => handleUpdateDomain(
                          domain.id,
                          domain.domain,
                          !domain.isActive,
                      )}
                  />
                </Col>
              </Row>
            </Card>
          ))}
        </div>
      </Spin>
    </Modal>
  );
};

export default InvalidDomainsModal;